import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconBlurb = props => (
  <SvgIcon {...props} viewBox="0 0 18 17">
    <path d="m16.4 0h-14.8c-0.88 0-1.6 0.72-1.6 1.6v15.4l4-3 12.4 0.015c0.88 0 1.6-0.72 1.6-1.6v-10.815c0-0.88-0.72-1.6-1.6-1.6zm-0.4 12h-12l-2 2v-12.002h14v10.002zm-11-8h8v2h-8v-2zm0 4h6v2h-6v-2z" />
  </SvgIcon>
);

export default IconBlurb;



// WEBPACK FOOTER //
// ./src/components/icons/IconBlurb.js